import React from 'react';
import useCustomerProfile from '@/Hooks/useCustomerProfile';
import useAuth from '@/Hooks/useAuth';
import Background, { BackgroundType } from '@/Layouts/containers/Background';
import ManageProfiles from '@/Pages/CustomerProfile/ManageProfiles';
import useIsProfilePages from '@/Hooks/useIsProfilePages';
import { SELECT_PROFILE, MANAGE_PROFILE } from '../CustomerProfile/constants';

interface Props {
  children?: any;
}

const ProfileManager: React.FC<Props> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { selectedProfile } = useCustomerProfile();
  const isProfilePage = useIsProfilePages();

  return (isAuthenticated && !selectedProfile) || isProfilePage ? (
    <Background type={BackgroundType.Default}>
      <ManageProfiles pageType={!selectedProfile ? SELECT_PROFILE : MANAGE_PROFILE} />
    </Background>
  ) : (
    <React.Fragment key={selectedProfile?.id ?? undefined}>{children}</React.Fragment>
  );
};

export default ProfileManager;
